import React from 'react';

/**
 * Custom dot renderer for defect points
 * Renders a red triangle with an exclamation mark
 * Click handling is done by the parent component
 */
const DefectDot = (props) => {
  const { cx, cy, className } = props;
  const size = 12; // Triangle size

  return (
    <g
      className={className}
    >
      {/* Red triangle */}
      <path 
        d={`M${cx},${cy-size} L${cx+size},${cy+size*0.7} L${cx-size},${cy+size*0.7} Z`} 
        fill="#FF3A33"
        stroke="#CC0000"
        strokeWidth={1}
      />
      {/* White exclamation mark */}
      <text
        x={cx}
        y={cy + size*0.3}
        textAnchor="middle"
        fill="#FFFFFF"
        fontSize={size*1.2}
        fontWeight="bold"
        dominantBaseline="middle"
      >
        !
      </text>
    </g>
  );
};

export default DefectDot; 